<template>
  <div class="coater">
    <CoaterList />
  </div>
</template>

<script>
// @ is an alias to /src
import CoaterList from "@/components/CoaterList.vue";

export default {
  name: "Coater",
  components: {
    CoaterList
  }
};
</script>
